<template>
  <!-- <transition name="guide"> -->
    <div>
      <!-- <div class="modalBackColor"></div> -->
      <!-- [모달창]사용 가이드 -->
      <div class="modal_wrap">
        <div class="modal_title">
          <div><a class="back" @click="guideClose(subPath, type)">뒤로</a></div>
          <div class="modal_title_title">
            {{ $t('alarm.price.guide') }}
          </div>
          <div class="colse-btn" @click="guideClose(subPath, type)"><img src="@/assets/images/dark/icon_close.png" alt="close button" /></div>
        </div>
        <!-- 준비 중입니다 -->
        <!-- <div class="modal_content">
        <div class="guide_wrap">
          {{ $t('guide["guideText"]') }}
        </div>
      </div> -->
        <!-- 준비 중입니다 :End -->
        <div class="modal_content">
          <!-- 시세 사용 가이드 -->
          <div class="guide_wrap" v-if="subPath === 'price'">
            <h3>{{ $t('guide["price"]["title"]') }}</h3>
            <p class="guide_txt">
              {{ $t('guide["price"]["text1"]') }}
            </p>
            <P class="guide_img"
              ><img src="@/assets/images/dark/guide_001.png"
            /></P>
          </div>
          <!-- 시세 사용 가이드 :End -->
  
          <!-- 6.4 사용 가이드 -->
          <div class="guide_wrap" v-if="type =='score'">
            <h3>{{ $t('guide["score"]["title"]') }} </h3>
            <p class="guide_txt">
              {{ $t('guide["score"]["text1"]') }}<br /><br />
              {{ $t('guide["score"]["text2"]') }}<br /><br />
              {{ $t('guide["score"]["1"]') }}<br />
              {{ $t('guide["score"]["2"]') }}<br /><br />
              {{ $t('guide["score"]["text3"]') }}<br /><br />
              {{ $t('guide["score"]["text4"]') }}
            </p>
            <P class="guide_img"
              ><img src="@/assets/images/dark/guide_002.png"
            /></P>
          </div>
          <!-- 6.4 사용 가이드 :End -->
  
          <!-- 급등락 사용 가이드 -->
          <div class="guide_wrap" v-if="type == 'volatility'">
            <h3>{{ $t('guide["volume"]["title"]') }}</h3>
            <p class="guide_txt">
              {{ $t('guide["volume"]["text1"]') }}<br /><br />
              {{ $t('guide["volume"]["text2"]') }}<br /><br />
              {{ $t('guide["volume"]["text3"]') }}
            </p>
            <P class="guide_img"
              ><img src="@/assets/images/dark/guide_003.png"
            /></P>
          </div>
          <!-- 급등락 사용 가이드 :End -->
  
          <!-- 프리미엄 사용 가이드 -->
          <div class="guide_wrap" v-if="type == 'premium'">
            <h3>{{ $t('guide["pre"]["title"]') }}</h3>
            <p class="guide_txt">
              {{ $t('guide["pre"]["text1"]') }}<br /><br />
              {{ $t('guide["pre"]["text2"]') }}
            </p>
          </div>
          <!-- 프리미엄 사용 가이드 :End -->
  
          <!-- 프리미엄 프로 사용 가이드 -->
          <div class="guide_wrap" v-if="type == 'premium-pro'">
            <h3>{{ $t('guide["prePro"]["title"]') }}</h3>
            <p class="guide_txt">
              {{ $t('guide["prePro"]["text1"]') }}<br /><br />
              {{ $t('guide["prePro"]["text2"]') }}
            </p>
          </div>
          <!-- 프리미엄 프로 가이드 :End -->

          <!-- 프리미엄 rsi 사용 가이드 -->
          <div class="guide_wrap" v-if="subPath === 'premium' && type === 'rsi'">
            <h3>{{ $t('guide["rsi"]["title"]') }}</h3>
            <p class="guide_txt">
              {{ $t('guide["rsi"]["text1"]') }}<br /><br />
  
              {{ $t('guide["rsi"]["text2"]') }}
            </p>
          </div>
          <!-- 프리미엄 rsi 사용 가이드 :End -->
  
           <!-- 스마트 사용 가이드 -->
           <div class="guide_wrap" v-if="type == 'smart'">
            <h3>{{ $t('guide["smart"]["title"]') }}</h3>
            <p class="guide_txt">
              {{ $t('guide["smart"]["text1"]') }}<br /><br />
              {{ $t('guide["smart"]["text2"]') }}
            </p>
          </div>
          <!-- 스마트 가이드 :End -->
  
          <!-- 스마트 프로 사용 가이드 -->
          <div class="guide_wrap" v-if="type == 'smart-pro'">
            <h3>{{ $t('guide["smartPro"]["title"]') }}</h3>
            <p class="guide_txt">
              {{ $t('guide["smartPro"]["text1"]') }}<br /><br />
              {{ $t('guide["smartPro"]["text2"]') }}
            </p>
          </div>
          <!-- 스마트 프로 가이드 :End -->

          <!-- 로켓 사용 가이드 -->
          <div class="guide_wrap" v-if="subPath == 'rocket'">
            <h3>{{ $t('guide["sr"]["title2"]') }}</h3>
            <p class="guide_txt">
              {{ $t('guide["sr"]["text3"]') }}<br /><br />
              {{ $t('guide["sr"]["text4"]') }}
            </p>
          </div>
          <!-- 지지저항 가이드 :End -->

          <!-- 지지저항 사용 가이드 -->
          <div class="guide_wrap" v-if="subPath == 'support-resistance'">
            <h3>{{ $t('guide["sr"]["title"]') }}</h3>
            <p class="guide_txt">
              {{ $t('guide["sr"]["text1"]') }}<br /><br />
              {{ $t('guide["sr"]["text2"]') }}
            </p>
          </div>
          <!-- 지지저항 가이드 :End -->

          <!-- 즉시진입 사용 가이드 -->
          <div class="guide_wrap" v-if="subPath == 'next'">
            <h3>{{ $t("alarm.dashboard.next") }}</h3>
            <p>{{ $t("alarm.next.guide1") }}</p>
            <p>{{ $t("alarm.next.guide2") }}</p>
            <p>{{ $t("alarm.next.guide3") }}</p>
            <p>{{ $t("alarm.next.guide4") }}</p>
          </div>
          <!-- 즉시진입 가이드 :End -->


          <!-- 신호등 사용 가이드 -->
          <div class="guide_wrap" v-if="subPath == 'light' || subPath == 'light-detail'">
            <h3>{{ $t("guide.light.title") }}</h3>
            <p>{{ $t("guide.light.text1") }}</p>
            <p v-dompurify-html="$t('guide.light.text2')"></p>
          </div>
          <!-- 신호등 가이드 :End -->
      </div>
    </div>
      <!-- [모달창]거래소:End -->
    </div>
    <!-- </transition> -->
  </template>
  
  <script>
  import { mapState, mapMutations } from "vuex";
  
  export default {
    name: "GuideModal",
    computed: {
      ...mapState("coinReg", ["clickGuide"]),
  
      subPath() {
        return this.$route.query?.subPath
      },
  
      type() {
        return this.$route.query?.type;
      },
    },
    methods: {
      ...mapMutations("coinReg", ["changeGuide"]),

      guideClose(subPath, type) {
        if (subPath && type) {
          this.$router.push(`/alarm/${subPath}?type=${type}`)
          return;
        }

        this.$router.back();
      }
    }
  };
  </script>
  <style scoped>
  .modalBackColor {
    display: block;
  }
  .modal_wrap {
    display: block;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: var(--main-bgcolor);
    border-radius: 15px 15px 0 0;
    cursor: pointer;
    z-index: 10001;
  }
  .modal_title {
    padding: 12px 16px;
    border-radius: 0;
    background: var(--Grayscale-Gray100, #121415);

    color: var(--Main, #FFF);

    /* Heading 3 */
    font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px; /* 154.545% */

    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .colse-btn {
    width: 24px;
    height: 24px;
  }

  .colse-btn img {
    width: 100%;
    height: 100%;
  }
 

  .modal_content {
    height: calc(100% - 60px);
    margin-top: 60px;
    padding-top: 0;
  
    overflow-y: scroll;
    -ms-overflow-style: scroll;
    scrollbar-width: auto;
  }
  .back {
    display: block;
    width: 24px;
    height: 24px;
    background: url("@/assets/images/icon/arrow/arrow-left-white.png") no-repeat;
    background-size: 24px;
    text-indent: -9999px;
    font-size: 0;
    cursor: pointer;
  }
  </style>
  